import { compose } from 'recompose';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
// eslint-disable-line no-unused-vars
import moment from 'moment-timezone';
import get from 'lodash/get';
import fullcalendar from 'fullcalendar';
import withPermissions from '../../../../auth/utils/withPermissions';
import {
  prepareAppointment,
  isAppointmentsChanged,
  eventRender,
  eventAfterRender,
  eventClick,
  dayClick,
  canShowAppointmentOnCalendar,
} from '../../../../common/helpers/fullCalendar';
import config from '../../../../../config';
import withMinInterval from '../../../../common/hoc/withMinInterval';

class CalendarWidget extends Component {
  initiateCalendar(view, appointments, currentDate) {
    const { timezone, minInterval, user } = this.props;
    const prepareCalendarAppointment = appointment => prepareAppointment(appointment, timezone, minInterval, user);
    let appointmentsArray = [];
    if (appointments && appointments.length) {
      appointmentsArray = appointments
        .map(prepareCalendarAppointment)
        .filter(canShowAppointmentOnCalendar);
    }
    const eventCalendarClick = event => eventClick(event, appointmentsArray, this.props.permissions);
    const dayCalendarClick = (...args) => dayClick(...args, get(this.props, 'barberUser.id'), this.props.permissions);

    $(this.calendar).fullCalendar({
      defaultView: view,
      allDaySlot: false,
      events: appointmentsArray,
      timezone,
      firstDay: 0, // 0 = SUNDAY, 1 = MONDAY
      minTime: moment({
        hour: config.availableHours.start.hours,
        minute: config.availableHours.start.minutes,
      }).format('HH:mm:00'),
      maxTime: moment({
        hour: config.availableHours.end.hours,
        minute: config.availableHours.end.minutes,
      }).format('HH:mm:00'),
      slotEventOverlap: false,
      slotDuration: `00:${(`0${minInterval}`.slice(-2))}:00`,
      slotLabelInterval: '01:00:00',
      slotLabelFormat: 'h(:mm)a',
      timeFormat: 'h(:mm)a',
      displayEventEnd: true,
      defaultDate: currentDate,
      views: {
        week: {
          columnFormat: 'ddd DD',
        },
        month: {
          eventLimit: 4,
        },
      },
      nowIndicator: true,
      now: moment.tz(timezone).format(),
      eventRender,
      eventAfterRender,
      eventClick: eventCalendarClick,
      dayClick: dayCalendarClick,
    });
  }

  changeView(view) {
    $(this.calendar).fullCalendar('changeView', view);
  }

  componentDidMount() {
    const { appointments, currentView, currentDate } = this.props;
    this.initiateCalendar(currentView, appointments, currentDate);
  }

  componentWillReceiveProps(nextProps) {
    const { currentView, appointments, currentDate, timezone, user } = nextProps;
    if (currentView !== this.props.currentView) {
      this.changeView(currentView);
    }

    const isDateChanged = this.props.currentDate !== currentDate;
    if (isAppointmentsChanged(this.props.appointments, appointments, timezone, this.props.minInterval, user) || isDateChanged) {
      $(this.calendar).fullCalendar('destroy');
      this.initiateCalendar(currentView, appointments, currentDate);
    }
  }

  render() {
    return (
      <div ref={(el) => { this.calendar = el; }} />
    );
  }
}

CalendarWidget.propTypes = {
  currentView: PropTypes.string.isRequired,
  currentDate: PropTypes.string.isRequired,
  appointments: PropTypes.arrayOf(PropTypes.object),
  timezone: PropTypes.string.isRequired,
  permissions: PropTypes.object.isRequired,
  minInterval: PropTypes.number.isRequired,
  user: PropTypes.object.isRequired,
};
CalendarWidget.defaultProps = {
  appointments: [],
};

const mapStateToProps = state => ({
  timezone: state.auth.timezone,
  barberUser: state.auth.barberUser,
  user: state.auth.user,
});

export default compose(
  withPermissions,
  withMinInterval,
  connect(mapStateToProps, null),
)(CalendarWidget);
